import { useEffect, useRef, useState } from "react";
import './MultioptionButton.css';

const MultioptionButton = ({ buttons, buttonCallbacks, buttonEventParams, hidden }) => {

  const [currentButton, setCurrentButton] = useState(null);
  const [open, setOpen] = useState(false);
  const componentRef = useRef(null);

  useEffect(()=>{
  },[hidden])

  useEffect(() => {
  }, [currentButton])

  const optionsClick = (e) => {
    e.stopPropagation();
    setOpen(prev => !prev);
  }

  const buttonClick = (buttonItem, e) => {
    buttonCallbacks?.[buttonItem.id]?.(buttonEventParams ?? e);
    buttonItem?.onClick?.(buttonEventParams ?? e);
    setCurrentButton(buttonItem);
    setOpen(prev => !prev);
  }

  useEffect(() => {
    setCurrentButton(prev => !prev ? buttons[0] : prev);
  }, [buttons]);

  const mainButtonClick = (buttonItem, e) => {
    buttonCallbacks?.[buttonItem.id]?.(buttonEventParams ?? e);
    buttonItem?.onClick?.(buttonEventParams ?? e);
    setCurrentButton(buttonItem);
  }

  useEffect(() => {
    // This function checks if a click is outside the component
    const handleClickOutside = (event) => {
      if (componentRef.current && !componentRef.current.contains(event.target)) {
        setOpen(false); // Close the component if the click is outside
      }
    };

    // Add event listener on mount
    document.addEventListener('click', handleClickOutside);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [setOpen]);

  return (
    <div onClick={(e)=>e.stopPropagation()} className={`multioption-button-component ${hidden ? 'hidden': ''}`} ref={componentRef}>
      <button className={`filled iconTextButton ${open ? 'open' : ''}`} onClick={(e) => mainButtonClick(currentButton, e)}>
        <div>
          {currentButton?.icon && <i className={currentButton?.icon}></i>}
          <span>
            {currentButton?.label}
          </span>
        </div>
        <div tabIndex={0} onClick={optionsClick}>
          <i className="icon-arrow-down"></i>
        </div>
      </button>
      <div className={`button-options ${open ? 'open' : ''}`} >
        {buttons.map(buttonItem => (buttonItem.id !== currentButton?.id) &&
          <button disabled={!open} className={`filled ${buttonItem.type}`} key={buttonItem.label} onClick={(e) => buttonClick(buttonItem, e)}>
            <div>
              {buttonItem?.icon && <i className={buttonItem.icon}></i>}
              <span>
                {buttonItem.label}
              </span>
            </div>
          </button>)}
      </div>
    </div>
  );
}

export default MultioptionButton;